import { Button, ControlLabel } from 'react-bootstrap';
import React from 'react';

const GroupRow = ({ group, index, handleRemove }) => {
  return (
    <div key={`group${group.id}`} className="flex">
      <h3>
        <ControlLabel className="m-0">{index + 1}</ControlLabel>
      </h3>
      <div className="flex-1 m-l-8">
        <div className="form-group m-b-0">
          <input
            className="form-control"
            value={`${group.name} ${group.archived ? '(archived)' : ''} `}
            disabled
          />
        </div>
      </div>
      <Button className="btn-delete m-l-8" onClick={() => handleRemove(group)}>
        Delete
      </Button>
    </div>
  );
};

export default GroupRow;
